import React from "react";
import PrimaryButton from "../../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import TextArea from "../../../components/globalComponents/textArea/TextArea";
import CustomUploadBox from "../../../components/globalComponents/customUploadBox/CustomUploadBox";
import "./LeaveApplicationStyle.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  userSliceFunction,
  leaveForm,
  getMissingData,
  clearState,
} from "../../../reducers/leaveSlice";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ErrorToast from "../../../components/Toast/ErrorToast";
import ConfirmationPopup from "../../../components/popups/confirmationPopup/ConfirmationPopup";
import * as filestack from "filestack-js";
import PageLoader from "../../../components/globalComponents/PageLoader/PageLoader";
import TextField from "../../../components/globalComponents/textFields copy/TextField";

const client = filestack.init("AXgXGi3jhSyiQo8NOKNfWz");
const LeaveApplication = () => {
  const { isFetching, missingLactures, isSuccess } = useSelector(userSliceFunction);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [typeOfLeave, setTypeOfLeave] = useState("Casual Leave");
  const [durationOfLeave, setDurationOfLeave] = useState("Multiple Days");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [active, setActive] = useState(false);
  const [load, setLoad] = useState(false);
  const [disable, setdisable] = useState(false);
  
  const [url, setUrl] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  

  const token = {};

  const handleStartDate = (e) => {
    if (durationOfLeave === "Single Day") {
      setStartDate(e.target.value);
      setEndDate(e.target.value);
    } else {
      setStartDate(e.target.value);
      setEndDate("");
    }
  };

  useEffect(() => {
    if (startDate && endDate) {
      dispatch(
        getMissingData({
          startTime: moment(startDate).format("YYYY-MM-DD"),
          endTime: moment(endDate).format("YYYY-MM-DD"),
        })
      );
    }
    // else{
    //   setIsShowError(true);
    //   setErrMessage("endDate is graeter then start date");
    // }
  }, [endDate]);

  const handleReason = (e) => {
    setReason(e.target.value);
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeOfLeave && durationOfLeave && startDate && endDate && reason) {
      var data = {
        typeOfLeave: typeOfLeave,
        durationOfLeave: durationOfLeave,
        startDate: startDate,
        endDate: endDate,
        reason: reason,
        uploadDocument: url,
        fileName:selectedKey,
      };
      dispatch(leaveForm(data));
    } else {
      setIsShowError(true);
      setErrMessage("All fields are mandatory!");
    }
  };

  const handleRemove = () => {
    setUrl("");
    setSelectedKey("");
  };
  const handleUpload = (event) => {
    if (event.target.files.length > 0 &&event.target.files[0].type==="application/pdf") {
      const files = event.target.files[0];

      setLoad(true);
      client.upload(files, {}, token).then((res) => {
        if (res) {
          setSelectedKey(res.name);
          setUrl(res.url);
          setLoad(false);
        } else {
          setLoad(false);
        }
      });
    }

    else{
      setIsShowError(true);
      setErrMessage("only pdf files are accepted!");

    }
  };
  useEffect(() => {
    if (isSuccess) {
      setActive(true);
    }
    dispatch(clearState());
  }, [isSuccess]);

  const handleClose=()=>{
    setActive(false);
    setStartDate("")
    setEndDate("")
    setReason("")
    setTypeOfLeave("Casual Leave")
    setDurationOfLeave("Multiple Days")
  }





  return (
    <>
      {(isFetching || load) && <PageLoader />}

      <div className="pageHeader">
        <ConfirmationPopup
          btnType={"successBtn"}
          btnHandler={() => navigate("/leaveList", { exact: true })}
          title="Request Raised"
          show={active}
          handleClose={handleClose}
          boldText="You have successfully raised the leave request"
          text="for more information view details."
          btnText="Continue"
          
        />

        <ErrorToast
          show={isShowError}
          setShow={() => setIsShowError(false)}
          message={errMessage}
        />
        <p className="componentHeading"></p>

        <div className="pageTogglers">
          <div className="pageToggler active">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.30662 1.04169H12.6935C13.3708 1.04168 13.9172 1.04168 14.3596 1.07782C14.8151 1.11504 15.2152 1.19367 15.5854 1.38229C16.1734 1.6819 16.6515 2.15996 16.9511 2.74797C17.1397 3.11815 17.2184 3.51827 17.2556 3.9738C17.2917 4.41622 17.2917 4.96256 17.2917 5.63992V10.4167C17.2917 10.7619 17.0119 11.0417 16.6667 11.0417C16.3215 11.0417 16.0417 10.7619 16.0417 10.4167V5.66669C16.0417 4.95631 16.0412 4.46111 16.0097 4.07559C15.9788 3.69736 15.9212 3.48005 15.8373 3.31545C15.6576 2.96265 15.3707 2.67581 15.0179 2.49605C14.8533 2.41218 14.636 2.35457 14.2578 2.32367C13.8723 2.29217 13.3771 2.29169 12.6667 2.29169H7.33337C6.623 2.29169 6.1278 2.29217 5.74227 2.32367C5.36404 2.35457 5.14674 2.41218 4.98214 2.49605C4.62934 2.67581 4.3425 2.96265 4.16274 3.31546C4.07887 3.48005 4.02126 3.69736 3.99036 4.07559C3.95886 4.46111 3.95837 4.95631 3.95837 5.66669V14.3334C3.95837 15.0437 3.95886 15.5389 3.99036 15.9245C4.02126 16.3027 4.07887 16.52 4.16274 16.6846C4.3425 17.0374 4.62934 17.3242 4.98214 17.504C5.14674 17.5879 5.36404 17.6455 5.74227 17.6764C6.1278 17.7079 6.623 17.7084 7.33337 17.7084H10C10.3452 17.7084 10.625 17.9882 10.625 18.3334C10.625 18.6785 10.3452 18.9584 10 18.9584H7.30661C6.62925 18.9584 6.08291 18.9584 5.64048 18.9222C5.18495 18.885 4.78484 18.8064 4.41465 18.6177C3.82665 18.3181 3.34858 17.8401 3.04898 17.2521C2.86036 16.8819 2.78173 16.4818 2.74451 16.0262C2.70836 15.5838 2.70837 15.0375 2.70837 14.3601V5.63993C2.70837 4.96257 2.70836 4.41622 2.74451 3.9738C2.78173 3.51827 2.86036 3.11815 3.04898 2.74797C3.34858 2.15996 3.82665 1.6819 4.41465 1.38229C4.78484 1.19367 5.18495 1.11504 5.64048 1.07782C6.08291 1.04168 6.62925 1.04168 7.30662 1.04169ZM6.04171 5.83335C6.04171 5.48818 6.32153 5.20835 6.66671 5.20835H13.3334C13.6786 5.20835 13.9584 5.48818 13.9584 5.83335C13.9584 6.17853 13.6786 6.45835 13.3334 6.45835H6.66671C6.32153 6.45835 6.04171 6.17853 6.04171 5.83335ZM6.04171 9.16669C6.04171 8.82151 6.32153 8.54169 6.66671 8.54169H11.6667C12.0119 8.54169 12.2917 8.82151 12.2917 9.16669C12.2917 9.51186 12.0119 9.79169 11.6667 9.79169H6.66671C6.32153 9.79169 6.04171 9.51186 6.04171 9.16669ZM6.04171 12.5C6.04171 12.1548 6.32153 11.875 6.66671 11.875H8.33337C8.67855 11.875 8.95837 12.1548 8.95837 12.5C8.95837 12.8452 8.67855 13.125 8.33337 13.125H6.66671C6.32153 13.125 6.04171 12.8452 6.04171 12.5ZM17.942 13.3081C18.1861 13.5522 18.1861 13.9479 17.942 14.192L14.192 17.942C13.9479 18.186 13.5522 18.186 13.3081 17.942L11.6414 16.2753C11.3974 16.0312 11.3974 15.6355 11.6414 15.3914C11.8855 15.1473 12.2812 15.1473 12.5253 15.3914L13.75 16.6161L17.0581 13.3081C17.3022 13.064 17.6979 13.064 17.942 13.3081Z"
                fill="#262626"
              />
            </svg>
            Leave Application Form
          </div>
        </div>
        <div></div>
      </div>

      <div className="leaveApplicationOuter">
        <div className="noteBox">
          <p className="noteHeading">
            Note: The leave will be approved only for the following valid
            reasons
          </p>
          <div className="notePoints">
            <p className="notePoint">
              1. Leave ( Please attach the medical certificate)
            </p>
            <p className="notePoint">
              2. External Examination (please attach proof)
            </p>
          </div>
          <p className="additionalText">
            Please note that if your leave request is not approved, you will be
            penalised according to the attendance norms defined in the student
            handbook. An approved leave will be exempted from penalties.
          </p>
        </div>
        <div className="leaveApplicationContainer">
          <div className="leaveFrom">
            <div className="form2Col">
              <div className="formGrp">
                <label htmlFor="">
                  Type of Leave <span className="impMark">*</span>
                </label>
                <div className="radioGrpFlex">
                  {[
                    { label: "Medical ", value: "Medical Leave" },
                    { label: "Casual", value: "Casual Leave" },
                  ].map((val, i) => (
                    <div className="radioBtn" key={val}>
                      <input
                        type="radio"
                        name="radio-group1"
                        id={i + "g"}
                        value={val.value}
                        checked={typeOfLeave === val.value ? true : false}
                        onChange={(e) => {

                          setTypeOfLeave(e.target.value);
                          if (val.value === "Casual Leave") {
                            setUrl("");
                            setStartDate("");
                            setEndDate("");
                          } else if (val.value === "Medical Leave") {
                            setStartDate("");
                            setEndDate("");
                          }
                        }}
                      />
                      <label for={i + "g"}>{val.label}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="formGrp">
                <label htmlFor="">
                  Duration of Leave <span className="impMark">*</span>
                </label>
                <div className="radioGrpFlex">
                  {[
                    { label: "Single", value: "Single Day" },
                    { label: "Multiple", value: "Multiple Days" },
                  ].map((val, i) => (
                    <div className="radioBtn" key={val}>
                      <input
                        type="radio"
                        name="radio-group"
                        id={i}
                        value={val.value}
                        checked={durationOfLeave === val.value ? true : false}
                        onChange={(e) => {
                          console.log("changingg");
                          setDurationOfLeave(e.target.value);
                          setEndDate("");
                          setStartDate("");
                          
                        }}
                      />
                      <label for={i}>{val.label}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="formGrp">
              <label htmlFor="">
                Start Date <span className="impMark">*</span>
              </label>

              <TextField
                inputType={"date"}
                placeholder={"-- Select your date --"}
                value={startDate}
                onChange={(e) => {
                  handleStartDate(e);
                }}
                
                min={moment(typeOfLeave==="Casual Leave"?new Date():"").format("YYYY-MM-DD")}
               
              />
            </div>
            <div className="formGrp">
              {durationOfLeave === "Single Day" ? (
                ""
              ) : (
                <>
                  <label htmlFor="">
                    End Date <span className="impMark">*</span>
                  </label>

                  <TextField
                   
                    inputType={"date"}
                    placeholder={"-- Select your date --"}
                    value={endDate}
                    onChange={(e) => {

                      if ( new Date(e.target.value).getTime() > new Date(startDate).getTime()){setEndDate(e.target.value);}
                     
                    }}
                    min={moment(startDate).add(1,"days").format("YYYY-MM-DD")}
                    
                  />
                </>
              )}
            </div>
            <div className="formGrp">
              <TextArea
              value={reason}
                labelName={"Specify the accurate reason for leave application?"}
                isImportant={true}
                placeholder={"Type the details here..."}
                onChange={handleReason}
              />
            </div>
            <div className="formGrp">
              {typeOfLeave === "Medical Leave" ? (
                <CustomUploadBox
                
                label={"Upload pdf File"}
                onChange={handleUpload}
                value={selectedKey}
                newValue ={(e) => e.target.value}
                handleRemove={handleRemove}
                accept={".pdf"}
                
                />
              ) : (
                ""
              )}
            </div>
            {console.log(missingLactures, "ghkljjk")}
            {endDate !== "" && missingLactures?.length !== 0 ? (
              <div className="missingTableContainer">
                <table
                  className="missingLectureTable"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <thead>
                    <tr>
                      <th className="missingTd">
                        <p>Missing Session</p>{" "}
                        <p>Total Missed : {missingLactures?.length}</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {missingLactures?.map((item,i) => {
                      return (
                        <tr key={i}>
                          <td>{item.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="leaveFormFooter">
            <PrimaryButton
              classname={"primaryBtn"}
              children={"Submit"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveApplication;
